import $ from "jquery";

docReady(function () {
    if(document.getElementById("AddToCartModal")) {
        window.modalAddToCart = new Vue({
            el: '#AddToCartModal',
            data: {
                id: 0,
                count: 1,
                price: 0,
                sum: 0,
                currency: '',
                origin_price: 0,
                origin_sum: 0,
                origin_currency: '',
                image: 0,
                name: '',
                domain: '',
            },
            methods: {
                addItem() {
                    this.count++;
                    this.sum = this.sum + this.price;
                    this.origin_sum = this.origin_sum + this.origin_price;
                },
                removeItem() {
                    if (this.count > 1) {
                        this.count--;
                        this.sum = this.sum - this.price;
                        this.origin_sum = this.origin_sum - this.origin_price;
                    }
                },
                confirm(){
                    $('#AddToCartModal').modal('hide');
                    modalAddToCartSuccess.domain = this.domain;
                    modalAddToCartSuccess.name = this.name;
                    modalAddToCartSuccess.id = this.id;
                    modalAddToCartSuccess.image = this.image;
                    modalAddToCartSuccess.currency = this.currency;
                    modalAddToCartSuccess.sum = this.sum;
                    modalAddToCartSuccess.origin_price = this.origin_price;
                    modalAddToCartSuccess.origin_currency = this.origin_currency;
                    modalAddToCartSuccess.origin_sum = this.origin_sum;
                    modalAddToCartSuccess.count = this.count;
                    addGoodsToCart(modalAddToCartSuccess.domain, modalAddToCartSuccess.id ,1,{'items_cnt':this.count},function (){
                        $('#SuccessAddToCartModal').modal('show');
                        setTimeout(function (){
                            // img to svg start
                            $('img.img-svg').each(function () {
                                var $img = $(this);
                                var imgClass = $img.attr('class');
                                var imgURL = $img.attr('src');
                                $.get(imgURL, function (data) {
                                    var $svg = $(data).find('svg');
                                    if (typeof imgClass !== 'undefined') {
                                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                                    }
                                    $svg = $svg.removeAttr('xmlns:a');
                                    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                                        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                                    }
                                    $img.replaceWith($svg);
                                }, 'xml');
                            });
                            // img to svg end
                        },20);
                    })
                }
            },
            computed: {
                sumCount() {
                    return this.count;
                },
                sumPrice() {
                    return (this.sum<=0) ? __('negotiable'):(this.sum);
                },
                sumOriginPrice() {
                    return (this.origin_sum<=0) ? __('negotiable'):(this.origin_sum);
                }
            }
        });
    }
    if(document.getElementById("SuccessAddToCartModal")) {
        window.modalAddToCartSuccess = new Vue({
            el: '#SuccessAddToCartModal',
            data: {
                id: 0,
                count: 1,
                sum: 0,
                currency: '',
                origin_price: 0,
                origin_sum: 0,
                origin_currency: '',
                image: 0,
                name: '',
                domain: '',
                isGuest: isGuest
            },
            methods: {
                confirm(){
                    $('#SuccessAddToCartModal').modal('hide');
                    if(window.isGuest) {
                        $('#order_method').modal('show');
                    } else {
                        window.location.href = '/shop_cart/order_by_good_id/'+this.$data.id+'.html';
                    }

                },
                continueShopping(){
                    $('#SuccessAddToCartModal').modal('hide');
                },
                toFastRegister() {
                    $('#SuccessAddToCartModal').modal('hide');
                    $('#fastRegister').modal('show');
                }
            },
            computed: {
                sumCount() {
                    return this.count;
                },
                sumPrice() {
                    return (this.sum<=0) ? __('negotiable'):(this.sum);
                },
                sumOriginPrice() {
                    return (this.origin_sum<=0) ? __('negotiable'):(this.origin_sum);
                }
            }
        });
    }
    if(document.getElementById("fastRegister")) {
        intlTelInput(document.getElementById('fastregusername'), {
            preferredCountries: ['ua'],
            separateDialCode: true,
            hiddenInput: 'fastregusername',
            onlyCountries: ['ua','ru']
        });
        var password = Date.now();
        window.modalFastRegister = new Vue({
            el: '#fastRegister',
            data: {
                domain: $("[data-url-domain]").data('url-domain'),
                phone: '',
                code: '',
                viber: '',
                telegram: '',
                watsap: '',
                inProgress: false,
                inProgressCode: false,
                showCode: false,
            },
            methods: {
                sendCode(){
                    var that = this;
                    var username = "380"+that.$data.phone;
                    that.$data.inProgress = true;
                    $.ajax({
                        url: that.$data.domain+'auth/register/0.html?ajax=1',
                        dataType : "text",
                        type : "POST",
                        data : {
                            username: username,
                            viber: that.$data.viber,
                            telegram: that.$data.telegram,
                            watsap: that.$data.watsap,
                            codeIsPassword: 1,
                            password: password,
                            confirm_password: password,
                            role: 4
                        },
                        success: function (data) {
                            if(data !== 'ok') {
                                alert(__('namber_is_registration'))
                                that.$data.inProgress = false;
                            } else {
                                that.$data.showCode = true;
                            }
                        }
                    });
                },
                isFilled(){
                    return !this.$data.inProgress && (this.$data.phone.length === 9) && (/^\d+$/.test(this.$data.phone));
                },
                enterCode(){
                    var that = this;
                    this.$data.inProgressCode = true;
                    $.ajax({
                        url: that.$data.domain+'auth/phonecode/'+"380"+that.$data.phone+'.html?ajax=1',
                        dataType : "text",
                        type : "POST",
                        data : {
                            phonecode: this.$data.code
                        },
                        success: function (data) {
                            if(data !== 'ok') {
                                alert(__('wrong_code'))
                                that.$data.inProgressCode = false;
                            } else {
                                $.ajax({
                                    url: that.$data.domain+'auth/login.html?ajax=1',
                                    dataType: "text",
                                    type: "POST",
                                    data: {
                                        username: "380"+that.$data.phone,
                                        password: that.$data.code
                                    },
                                    success: function (data) {
                                        alert(__('account_activated'))
                                        window.location.reload();
                                    }
                                });
                            }
                        }
                    });
                }
            },
        });
    }
});
